import React from 'react';
import { Lock, Download } from 'lucide-react';
interface FinalConversionProps {
  totalPrice: number;
  isBumpSelected: boolean;
}
export function FinalConversion({
  totalPrice,
  isBumpSelected
}: FinalConversionProps) {
  const formatPrice = (price: number) => price.toFixed(2);
  const handleCheckoutClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to appropriate Shopify checkout based on bump selection
    const checkoutUrl = isBumpSelected ? 'https://www.tubienestarinterno.com/cart/53346665300305:1' : 'https://www.tubienestarinterno.com/cart/53346355937617:1';
    window.location.href = checkoutUrl;
  };
  const savings = isBumpSelected ? 17.05 + 9.1 : 17.05;
  return <section className="py-12 px-4 bg-white" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        {/* Summary Box */}
        <div className="border-2 border-gray-900 rounded-[20px] p-6 sm:p-8 mb-6 bg-gray-50" data-id="element-62">
          <h3 className="text-2xl font-bold font-serif text-gray-900 mb-5 text-center" data-id="element-63">
            ESTO ES LO QUE RECIBES HOY
          </h3>
          <ul className="space-y-3 mb-6 text-gray-600 font-medium" data-id="element-64">
            <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-65">
              <span data-id="element-66">Método Principal DOG-CALM™ (7 días)</span>
              <span data-id="element-67">$47.00</span>
            </li>
            <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-68">
              <span data-id="element-69">Bono #1: Código del Silencio</span>
              <span data-id="element-70">$27.00</span>
            </li>
            <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-71">
              <span data-id="element-72">Bono #2: El Interruptor de Cortisol</span>
              <span data-id="element-73">$17.00</span>
            </li>
            <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-74">
              <span data-id="element-75">Bono #3: Guía Elevador y Pasillo</span>
              <span data-id="element-76">$17.00</span>
            </li>
            <li className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-77">
              <span data-id="element-78">Bono #4: Plantilla SOS</span>
              <span data-id="element-79">$12.00</span>
            </li>
            {isBumpSelected && <li className="flex justify-between items-center border-b border-gray-200 pb-2 text-brand-teal" data-id="element-80">
                <span className="font-bold" data-id="element-81">+ Código del Silencio (Bump)</span>
                <span className="font-bold" data-id="element-82">$4.90</span>
              </li>}
          </ul>
          <div className="bg-gray-900 text-white rounded-xl p-4 flex flex-col items-center text-center font-bold text-lg space-y-1" data-id="element-83">
            <span className="text-brand-gold" data-id="element-84">VALOR DE BONOS: GRATIS</span>
            <span data-id="element-85">PRECIO TOTAL HOY: ${formatPrice(totalPrice)} USD</span>
          </div>
        </div>

        {/* No es relleno text */}
        <div className="text-center mb-8" data-id="element-86">
          <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-87">
            <strong className="text-gray-900" data-id="element-88">
              No te estoy regalando relleno.
            </strong>{' '}
            Te doy las 4 herramientas que hacen que el método funcione. Sin el
            Código del Silencio, los vecinos seguirán quejándose. Sin la Guía
            del Elevador, salir de casa seguirá siendo un campo de batalla.
          </p>
        </div>

        {/* Offer Badge & CTA */}
        <div className="text-center" data-id="element-89">
          <div className="inline-block bg-brand-teal text-white font-bold px-6 py-2 rounded-full mb-5 uppercase tracking-wide text-sm" data-id="element-90">
            OFERTA DE LANZAMIENTO - EMPIEZA TU DÍA 1 HOY
          </div>

          <div className="mb-5" data-id="element-91">
            <div className="text-gray-400 line-through text-2xl font-bold mb-1" data-id="element-92">
              $27.00
            </div>
            <div className="text-5xl md:text-6xl font-black text-brand-gold mb-2" data-id="element-93">
              ${formatPrice(totalPrice)} USD
            </div>
            <div className="text-sm font-bold text-green-600 uppercase tracking-wider" data-id="element-94">
              AHORRAS ${formatPrice(savings)} USD
            </div>
          </div>

          <button onClick={handleCheckoutClick} className="w-full max-w-md mx-auto bg-brand-gold hover:bg-yellow-500 text-gray-900 font-black py-5 px-8 rounded-[20px] shadow-xl transition-all transform hover:-translate-y-1 text-lg sm:text-xl block" data-id="element-95">
            SÍ, QUIERO PASEOS EN PAZ (${formatPrice(totalPrice)} USD)
          </button>

          <div className="mt-5 flex items-center justify-center space-x-6 text-gray-500 text-sm font-medium" data-id="element-96">
            <span className="flex items-center" data-id="element-97">
              <Lock className="w-4 h-4 mr-1.5" data-id="element-98" /> Pago Seguro
            </span>
            <span className="flex items-center" data-id="element-99">
              <Download className="w-4 h-4 mr-1.5" data-id="element-100" /> Acceso Inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}